export default __webpack_public_path__ + "KaTeX_Math-Italic.cae7ea2682cff6985955cd2cf261504e.ttf";